import React from 'react'
import { Component } from 'reflux'
import { PurchaseOrderStore, PurchaseOrderStoreActions, STATUS } from '../../stores/purchaseOrderStore'
import {
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  TableFooter,
  IconButton,
  Tooltip,
  CircularProgress,
  Typography,
  Box,
  Chip,
  TextField,
  TablePagination,
  Checkbox,
  Tabs,
  Tab
} from '@material-ui/core'
import ArchiveIcon from '@material-ui/icons/Archive'
import AssignmentIcon from '@material-ui/icons/Assignment'
import { toast } from 'react-toastify'

export default class PurchaseOrderReceive extends Component {
  constructor(props) {
    super(props)
    this.stores = [PurchaseOrderStore]
    this.storeKeys = ['purchaseOrdersToReceive', 'purchaseOrdersToReceiveTotalCount', 'purchaseOrdersToReceiveQuery', 'status']

    this.state = {
      ...this.state,
      search: '',
      page: 0,
      rowsPerPage: 10,
      tab: 'SENT',
      selectedPOs: [],
      selectedSupplierUID: null
    }
  }

  buildReceiveQuery = (over = {}) => {
    const tab = over.tab ?? this.state.tab
    const statusIn = tab && tab !== 'ALL' ? [tab] : []
    return {
      page: (over.page ?? this.state.page) + 1,
      pageSize: over.pageSize ?? this.state.rowsPerPage,
      searchTerm: over.searchTerm ?? this.state.search,
      supplierID: over.supplierID ?? this.state.supplierID ?? null,
      statusIn,
      isDropship: over.isDropship ?? this.state.isDropship ?? null,
      dateFrom: over.dateFrom ?? this.state.dateFrom ?? null,
      dateTo: over.dateTo ?? this.state.dateTo ?? null,
      sortField: over.sortField ?? 'PurchaseOrderNumber',
      sortDir: over.sortDir ?? 'DESC'
    }
  }

  componentDidMount() {
    const q = this.state.purchaseOrdersToReceiveQuery || {}
    const search = q.searchTerm || this.state.search
    const page = Math.max(0, (q.page || 1) - 1)
    const rowsPerPage = q.pageSize || this.state.rowsPerPage
    const tab = (Array.isArray(q.statusIn) && q.statusIn.length ? q.statusIn[0] : this.state.tab) || 'SENT'

    this.setState({ search, page, rowsPerPage, tab }, () => {
      const hasData = Array.isArray(this.state.purchaseOrdersToReceive) && this.state.purchaseOrdersToReceive.length > 0
      if (!hasData) {
        PurchaseOrderStoreActions.getPurchaseOrdersToReceivePaged(this.buildReceiveQuery({}))
      }
    })
  }

  translateStatus = status => {
    switch (status) {
      case 'NEW':
        return 'Ny'
      case 'SENT':
        return 'Sendt'
      case 'RECEIVED':
        return 'Modtaget'
      case 'PARTLY_RECEIVED':
        return 'Delvist modtaget'
      case 'CLOSED':
        return 'Lukket'
      default:
        return status
    }
  }

  componentDidUpdate() {
    if (this.state.status === STATUS.FETCHING_ERROR) {
      toast.error('Kunne ikke hente indkøbsordrer', {
        autoClose: 7500,
        onClose: () => {
          PurchaseOrderStoreActions.clearToast()
        }
      })
      PurchaseOrderStoreActions.clearToast()
    }
    if (this.state.status === STATUS.DELETE_ERROR) {
      toast.error('Kunne ikke slette indkøbsordre', {
        autoClose: 7500,
        onClose: () => {
          PurchaseOrderStoreActions.clearToast()
        }
      })
      PurchaseOrderStoreActions.clearToast()
    }
    if (this.state.status === STATUS.DELETE_SUCCESS) {
      toast.success('Indkøbsordre slettet', {
        autoClose: 7500,
        onClose: () => {
          PurchaseOrderStoreActions.clearToast()
        }
      })
      PurchaseOrderStoreActions.clearToast()
    }
  }

  openReceiveDetails = (poID = null) => {
    if (poID) {
      this.props.history.push({
        pathname: '/purchase-orders/receive/details',
        state: { purchaseOrderIDs: [poID] }
      })
    } else {
      this.props.history.push({
        pathname: '/purchase-orders/receive/details',
        state: { purchaseOrderIDs: this.state.selectedPOs }
      })
    }
  }

  openHandleOrder = poID => {
    this.props.history.push({
      pathname: '/purchase-orders/receive/handle',
      state: { purchaseOrderIDs: [poID] }
    })
  }

  handleTabChange = (e, value) => {
    this.setState({ tab: value, page: 0 })
    PurchaseOrderStoreActions.setPurchaseOrdersToReceiveQuery(this.buildReceiveQuery({ tab: value, page: 0 }))
  }

  handleSearchChange = e => {
    const search = e.target.value
    this.setState({ search, page: 0 })
    PurchaseOrderStoreActions.setPurchaseOrdersToReceiveQuery(this.buildReceiveQuery({ searchTerm: search, page: 0 }))
  }

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage })
    PurchaseOrderStoreActions.setPurchaseOrdersToReceiveQuery(this.buildReceiveQuery({ page: newPage }))
  }

  handleChangeRowsPerPage = event => {
    const rowsPerPage = parseInt(event.target.value, 10)
    this.setState({ rowsPerPage, page: 0 })
    PurchaseOrderStoreActions.setPurchaseOrdersToReceiveQuery(this.buildReceiveQuery({ page: 0, pageSize: rowsPerPage }))
  }

  handleSelectPO = po => {
    const id = po.PurchaseOrderID
    const supplierUID = po?.supplier?.supplierUID || po?.supplierUID || null
    this.setState(prev => {
      const current = Array.isArray(prev.selectedPOs) ? prev.selectedPOs : []
      const isSelected = current.includes(id)

      if (isSelected) {
        const next = current.filter(x => x !== id)
        return {
          selectedPOs: next,
          selectedSupplierUID: next.length ? prev.selectedSupplierUID : null
        }
      } else {
        if (current.length > 0 && prev.selectedSupplierUID && prev.selectedSupplierUID !== supplierUID) {
          return null
        }
        return {
          selectedPOs: [...current, id],
          selectedSupplierUID: supplierUID
        }
      }
    })
  }

  filterOrders(orders, search, tab) {
    let filtered = orders
    if (tab && tab !== 'ALL') {
      filtered = filtered.filter(po => po.purchaseOrderStatus === tab)
    }
    return filtered
  }

  render() {
    const orders = this.state.purchaseOrdersToReceive || []
    const totalCount = this.state.purchaseOrdersToReceiveTotalCount || 0
    const { page, rowsPerPage } = this.state

    return (
      <Paper style={{ padding: 16, border: '1px solid #e0e0e0', borderRadius: 8 }}>
        <Tabs value={this.state.tab} onChange={this.handleTabChange} indicatorColor='primary' textColor='primary' style={{ marginBottom: 16 }}>
          <Tab label='Afventende' value='SENT' />
          <Tab label='Delvist modtaget' value='PARTLY_RECEIVED' />
          <Tab label='Modtaget' value='RECEIVED' />
        </Tabs>
        <Box display='flex' alignItems='center' justifyContent='space-between' mb={2}>
          <Typography variant='h6'>Indkøbsordre oversigt</Typography>
          <TextField
            label='Søg leverandør, CVR eller PO nr.'
            variant='outlined'
            size='small'
            value={this.state.search}
            onChange={this.handleSearchChange}
            style={{ width: 300 }}
          />
        </Box>
        <TableContainer>
          <Table size='small'>
            <TableHead>
              <TableRow>
                <TableCell padding='checkbox'></TableCell>
                <TableCell>PO Nummer</TableCell>
                <TableCell>Firma </TableCell>
                <TableCell>Oprettelses dato</TableCell>
                <TableCell>Ordre type</TableCell>
                <TableCell>Beløb</TableCell>
                <TableCell>Antal Produkter</TableCell>
                <TableCell style={{ width: 120, minWidth: 120, maxWidth: 120 }}>Status</TableCell>
                <TableCell align='right'>Handlinger</TableCell>
              </TableRow>
            </TableHead>

            {this.state.status === STATUS.IS_FETCHING ? (
              <TableRow>
                <TableCell colSpan={100} align='center'>
                  <CircularProgress size={24} />
                </TableCell>
              </TableRow>
            ) : (
              <TableBody>
                {orders.map(po => {
                  const totalAmount = (po.purchaseOrderlines || []).reduce((sum, l) => sum + (l.pricePerItem || 0) * (l.amountOfProducts || 0), 0)
                  const productCount = (po.purchaseOrderlines || []).length

                  let chipStyle = {}
                  if (po.purchaseOrderStatus === 'NEW') chipStyle = { background: '#e0e0e0', color: '#222' }
                  if (po.purchaseOrderStatus === 'SENT') chipStyle = { background: '#1976d2', color: '#fff' }
                  if (po.purchaseOrderStatus === 'RECEIVED') chipStyle = { background: '#388e3c', color: '#fff' }
                  if (po.purchaseOrderStatus === 'PARTLY_RECEIVED') chipStyle = { background: 'orange', color: '#fff' }
                  if (po.purchaseOrderStatus === 'CLOSED') chipStyle = { background: '#616161', color: '#fff' }

                  return (
                    <TableRow key={po.PurchaseOrderID}>
                      <TableCell padding='checkbox'>
                        {this.state.tab === 'SENT' && (
                          <Checkbox
                            checked={(this.state.selectedPOs || []).includes(po.PurchaseOrderID)}
                            onChange={() => this.handleSelectPO(po)}
                            disabled={
                              this.state.selectedPOs &&
                              this.state.selectedPOs.length > 0 &&
                              po.supplier?.supplierUID !== this.state.selectedSupplierUID
                            }
                          />
                        )}
                      </TableCell>
                      <TableCell>{po.purchaseOrderNumber}</TableCell>
                      <TableCell>
                        {po.supplier?.supplierName}
                        <br />
                        <span style={{ fontSize: 12, color: '#888' }}>CVR: {po.supplier?.corporateIdentificationNumber}</span>
                      </TableCell>
                      <TableCell>{po.dateCreated ? new Date(po.dateCreated).toLocaleDateString('da-DK') : 'Ikke angivet'}</TableCell>
                      <TableCell>{po.isDropShip ? 'Dropship' : 'Almindelig'}</TableCell>
                      <TableCell>
                        {totalAmount.toLocaleString('da-DK', { minimumFractionDigits: 2 })} {po.currency || 'DKK'}
                      </TableCell>
                      <TableCell>{productCount}</TableCell>
                      <TableCell>
                        <Chip label={this.translateStatus(po.purchaseOrderStatus)} style={chipStyle} size='small' />
                      </TableCell>
                      <TableCell align='right'>
                        {this.state.tab === 'RECEIVED' ? (
                          <Tooltip title='Håndter'>
                            <IconButton size='small' color='primary' onClick={() => this.openHandleOrder(po.PurchaseOrderID)}>
                              <AssignmentIcon />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <Tooltip title='Modtag'>
                            <IconButton size='small' color='primary' onClick={() => this.openReceiveDetails(po.PurchaseOrderID)}>
                              <ArchiveIcon />
                            </IconButton>
                          </Tooltip>
                        )}
                      </TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            )}

            {(!orders || orders.length === 0) && this.state.status !== STATUS.IS_FETCHING && (
              <TableFooter>
                <TableRow>
                  <TableCell colSpan={100} align='center'>
                    <Typography variant='body2' color='textSecondary'>
                      Ingen indkøbsordrer fundet.
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableFooter>
            )}
          </Table>
        </TableContainer>

        <TablePagination
          component='div'
          count={totalCount}
          page={page}
          onPageChange={this.handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={this.handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          labelRowsPerPage='Rækker pr. side'
        />
      </Paper>
    )
  }
}
